"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfResetPasswordInput = instanceOfResetPasswordInput;
exports.ResetPasswordInputFromJSON = ResetPasswordInputFromJSON;
exports.ResetPasswordInputFromJSONTyped = ResetPasswordInputFromJSONTyped;
exports.ResetPasswordInputToJSON = ResetPasswordInputToJSON;
/**
 * Check if a given object implements the ResetPasswordInput interface.
 */
function instanceOfResetPasswordInput(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function ResetPasswordInputFromJSON(json) {
    return ResetPasswordInputFromJSONTyped(json, false);
}
function ResetPasswordInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
function ResetPasswordInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
    };
}
